import Reveal from "@/components/Reveal";
import PageHero from "@/components/PageHero";
import ContactForm from "@/components/ContactForm";
import { Mail, Phone, Smartphone, MapPin } from "lucide-react";
import { BRAND, IMAGES } from "@/lib/data";

const Contact = () => {
  return (
    <main data-testid="page-contact">
      <PageHero
        eyebrow="Contact"
        title="Contact Us."
        intro="Tell us about your project and we'll get back to you."
      />

      <section className="section bg-white">
        <div className="container-kc">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
            <aside className="lg:col-span-4">
              <Reveal>
                <div className="eyebrow eyebrow--gold mb-4">Direct Lines</div>
                <h2 className="h-display text-3xl md:text-4xl">Talk to our team.</h2>
                <p className="text-gray-600 mt-6 leading-relaxed">
                  Whether you have a fully scoped engagement or are exploring a possible project, we
                  will help you find the right path forward.
                </p>

                <div className="mt-10 space-y-6">
                  <div className="flex items-start gap-4">
                    <span className="w-10 h-10 inline-flex items-center justify-center border border-gray-200 text-[#000000] shrink-0"><Mail size={16} /></span>
                    <div>
                      <div className="eyebrow">Email</div>
                      <a href={`mailto:${BRAND.email}`} className="text-[#000000] hover:text-[#C5A880] transition-colors mt-1 inline-block break-all" data-testid="contact-info-email">
                        {BRAND.email}
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <span className="w-10 h-10 inline-flex items-center justify-center border border-gray-200 text-[#000000] shrink-0"><Phone size={16} /></span>
                    <div>
                      <div className="eyebrow">Office</div>
                      <a href={`tel:+1${BRAND.office.replace(/\D/g, "")}`} className="text-[#000000] hover:text-[#C5A880] transition-colors mt-1 inline-block" data-testid="contact-info-office">
                        {BRAND.office}
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <span className="w-10 h-10 inline-flex items-center justify-center border border-gray-200 text-[#000000] shrink-0"><Smartphone size={16} /></span>
                    <div>
                      <div className="eyebrow">Cell</div>
                      <a href={`tel:+1${BRAND.cell.replace(/\D/g, "")}`} className="text-[#000000] hover:text-[#C5A880] transition-colors mt-1 inline-block" data-testid="contact-info-cell">
                        {BRAND.cell}
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <span className="w-10 h-10 inline-flex items-center justify-center border border-gray-200 text-[#000000] shrink-0"><MapPin size={16} /></span>
                    <div>
                      <div className="eyebrow">Office</div>
                      <div className="text-[#000000] mt-1 leading-relaxed">{BRAND.address}</div>
                    </div>
                  </div>
                </div>

                <div className="mt-12 pt-10 border-t border-gray-200">
                  <div className="eyebrow eyebrow--gold mb-4">Response Time</div>
                  <p className="text-gray-600 leading-relaxed">
                    All inquiries are reviewed personally and answered within one business day.
                  </p>
                </div>

                <div className="mt-10 aspect-[4/3] overflow-hidden bg-gray-100" data-testid="contact-image">
                  <img src={IMAGES.contactDC} alt="Washington, DC streetscape" className="w-full h-full object-cover" loading="lazy" />
                </div>
              </Reveal>
            </aside>

            <div className="lg:col-span-8">
              <Reveal delay={0.1}>
                <ContactForm />
              </Reveal>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;
